module.exports = __webpack_public_path__ + "static/media/01_720.ee170609.jpeg";